// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.security-form-container {
    background: #e3f0f7;
    border: 1px solid #577481;
    border-radius: 6px;
    padding: 1rem;
}

    .security-form-container label {
        display: block;
        margin-bottom: 1rem;
        font-weight: 600;
        color: #2c3e50;
    }

    .security-form-container input[type="text"],
    .security-form-container input[type="date"],
    .security-form-container select,
    .security-form-container textarea {
        width: 100%;
        padding: 8px;
        margin-top: 0.25rem;
        border-radius: 5px;
        border: 1px solid #ccc;
        resize: vertical;
        font-size: 1rem;
    }

    .security-form-container input[type="checkbox"] {
        margin-right: 8px;
    }

    .security-form-container button {
        margin-top: 1rem;
        padding: 12px 24px;
        background-color: #0061b0;
        color: white;
        border: none;
        border-radius: 6px;
        cursor: pointer;
        font-weight: 700;
        transition: background-color 0.3s ease;
    }

        .security-form-container button:hover {
            background-color: #004880;
        }
`, "",{"version":3,"sources":["webpack://./src/pages/demo/forms/SecurityForm.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;;IAEI;QACI,cAAc;QACd,mBAAmB;QACnB,gBAAgB;QAChB,cAAc;IAClB;;IAEA;;;;QAII,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,kBAAkB;QAClB,sBAAsB;QACtB,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,yBAAyB;QACzB,YAAY;QACZ,YAAY;QACZ,kBAAkB;QAClB,eAAe;QACf,gBAAgB;QAChB,sCAAsC;IAC1C;;QAEI;YACI,yBAAyB;QAC7B","sourcesContent":[".security-form-container {\n    background: #e3f0f7;\n    border: 1px solid #577481;\n    border-radius: 6px;\n    padding: 1rem;\n}\n\n    .security-form-container label {\n        display: block;\n        margin-bottom: 1rem;\n        font-weight: 600;\n        color: #2c3e50;\n    }\n\n    .security-form-container input[type=\"text\"],\n    .security-form-container input[type=\"date\"],\n    .security-form-container select,\n    .security-form-container textarea {\n        width: 100%;\n        padding: 8px;\n        margin-top: 0.25rem;\n        border-radius: 5px;\n        border: 1px solid #ccc;\n        resize: vertical;\n        font-size: 1rem;\n    }\n\n    .security-form-container input[type=\"checkbox\"] {\n        margin-right: 8px;\n    }\n\n    .security-form-container button {\n        margin-top: 1rem;\n        padding: 12px 24px;\n        background-color: #0061b0;\n        color: white;\n        border: none;\n        border-radius: 6px;\n        cursor: pointer;\n        font-weight: 700;\n        transition: background-color 0.3s ease;\n    }\n\n        .security-form-container button:hover {\n            background-color: #004880;\n        }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
